/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnlinkInstrumentLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UnlinkInstrumentLink.pb'
import {UnlinkInstrumentLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UnlinkInstrumentLink.pb'


export const unlinkInstrumentLink = (request:UnlinkInstrumentLinkRequest, options?: CashRequestOptions) => post<UnlinkInstrumentLinkRequest, UnlinkInstrumentLinkResponse>("/2.0/cash/unlink-instrument-link", request, {...options, rejectOnError: true })